/**
 * Linen Wave (Shopify) — Theme JavaScript
 * Cart drawer (Shopify Cart AJAX API), mobile nav, header scroll,
 * announcement bar, accordions, scroll reveal, legal modals, free-gift coupon,
 * product-card swatch image swap.
 */

/* ============================================================
   Price formatting (mirrors the original site: whole-dollar $)
   ============================================================ */
function formatPrice(cents) {
  var n = (cents || 0) / 100;
  return '$' + n.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/, ',');
}

/* ============================================================
   CART — Shopify AJAX API
   ============================================================ */
function openCart() {
  document.getElementById('cartSidebar') && document.getElementById('cartSidebar').classList.add('open');
  document.getElementById('cartOverlay') && document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cartSidebar') && document.getElementById('cartSidebar').classList.remove('open');
  document.getElementById('cartOverlay') && document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

function updateCartCount(count, bump) {
  document.querySelectorAll('.cart-count').forEach(function (el) {
    el.textContent = count;
    el.classList.toggle('hidden', count === 0);
    if (bump) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  });
}

function renderCart(cart) {
  var itemsEl = document.getElementById('cartItems');
  var subtotalEl = document.getElementById('cartSubtotal');
  var footerEl = document.getElementById('cartFooter');
  if (!itemsEl) return;

  if (!cart.items || cart.items.length === 0) {
    var shopUrl = (document.getElementById('shopAllUrl') || {}).href || '/collections/all';
    itemsEl.innerHTML =
      '<div class="cart-empty">' +
        '<div class="cart-empty__icon">' +
          '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
            '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/>' +
          '</svg>' +
        '</div>' +
        '<p>Your bag is empty.</p>' +
        '<a href="' + shopUrl + '" class="btn btn--primary" onclick="closeCart()">Shop the Collection</a>' +
      '</div>';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = '';

  itemsEl.innerHTML = cart.items.map(function (item) {
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? item.variant_title.replace(/ \/ /g, ' · ')
      : '';
    var img = item.image ? item.image : (item.featured_image && item.featured_image.url);
    return (
      '<div class="cart-item" data-key="' + item.key + '">' +
        '<img class="cart-item__img" src="' + (img || '') + '" alt="' + item.product_title + '" loading="lazy">' +
        '<div class="cart-item__info">' +
          '<div class="cart-item__name">' + item.product_title + '</div>' +
          (variant ? '<div class="cart-item__variant">' + variant + '</div>' : '') +
          '<div class="cart-item__bottom">' +
            '<div class="cart-item__qty">' +
              '<button onclick="changeLineQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')" aria-label="Decrease">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button onclick="changeLineQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="cart-item__price">' + formatPrice(item.final_line_price) + '</span>' +
          '</div>' +
          '<button class="cart-item__remove" onclick="changeLineQty(\'' + item.key + '\', 0)">Remove</button>' +
        '</div>' +
      '</div>'
    );
  }).join('');

  if (subtotalEl) subtotalEl.textContent = formatPrice(cart.total_price);
}

function refreshCart(bump) {
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCart(cart);
      updateCartCount(cart.item_count, bump);
      return cart;
    });
}

window.addToCart = function (variantId, qty) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  })
    .then(function (r) { return r.json(); })
    .then(function () { return refreshCart(true); })
    .then(function () { openCart(); });
};

window.changeLineQty = function (key, qty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCart(cart); updateCartCount(cart.item_count, false); });
};

/* ============================================================
   PRODUCT CARD — swatch image swap & quick add
   ============================================================ */
window.swapCardImage = function (evt, swatchEl) {
  evt.preventDefault();
  evt.stopPropagation();
  var productId = swatchEl.dataset.productId;
  var newImage = swatchEl.dataset.image;
  var imgEl = document.getElementById('card-img-' + productId);
  if (imgEl && newImage) imgEl.src = newImage;
  var allSwatches = swatchEl.parentElement.querySelectorAll('[data-card-swatch]');
  allSwatches.forEach(function (s) { s.classList.remove('active'); s.style.boxShadow = ''; });
  swatchEl.classList.add('active');
  swatchEl.style.boxShadow = '0 0 0 2px #fff, 0 0 0 3px #555';
};

window.quickAddToCart = function (variantId) {
  if (!variantId) return;
  window.addToCart(parseInt(variantId, 10), 1);
};

/* ============================================================
   MOBILE NAV
   ============================================================ */
function toggleMobileNav() {
  var nav = document.getElementById('mobileNav');
  var btn = document.querySelector('.hamburger');
  if (!nav || !btn) return;
  var isOpen = nav.classList.toggle('open');
  btn.classList.toggle('open', isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';
}

/* ============================================================
   HEADER SCROLL
   ============================================================ */
function initHeaderScroll() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var update = function () { header.classList.toggle('scrolled', window.scrollY > 10); };
  window.addEventListener('scroll', update, { passive: true });
  update();
}

/* ============================================================
   ANNOUNCEMENT BAR
   ============================================================ */
function initAnnouncementBar() {
  var bar = document.querySelector('.announcement-bar');
  var close = document.querySelector('.announcement-bar__close');
  if (!bar || !close) return;
  if (sessionStorage.getItem('lw_ann_closed')) bar.classList.add('hidden');
  close.addEventListener('click', function () {
    bar.classList.add('hidden');
    sessionStorage.setItem('lw_ann_closed', '1');
  });
}

/* ============================================================
   ACCORDION (FAQ, product detail)
   ============================================================ */
function initAccordions(containerSelector) {
  var containers = document.querySelectorAll(containerSelector || '[data-accordion]');
  containers.forEach(function (container) {
    var items = container.querySelectorAll('[data-accordion-item]');
    items.forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        items.forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  });
}

/* ============================================================
   SCROLL REVEAL
   ============================================================ */
function initScrollReveal() {
  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('[data-reveal]').forEach(function (el) { obs.observe(el); });
}

/* ============================================================
   EMAIL SIGNUP
   ============================================================ */
function initEmailSignup() {
  document.querySelectorAll('[data-email-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var success = form.parentElement && form.parentElement.querySelector('.email-signup__success');
      if (!input || !input.value) return;
      form.style.display = 'none';
      if (success) success.style.display = 'block';
    });
  });
}

/* ============================================================
   FREE GIFT COUPON
   ============================================================ */
window.claimCode = function (color) {
  var isWhite = color === 'white';
  var code = isWhite ? 'WHITEPILLOW' : 'BEIGEPILLOW';
  var note = isWhite
    ? 'White pillowcases pair beautifully with any color in our collection.'
    : 'Beige pillowcases bring a warm, natural tone to any bedroom.';
  var codeText = document.getElementById('codeText');
  var colorNote = document.getElementById('colorNote');
  if (codeText) codeText.textContent = code;
  if (colorNote) colorNote.textContent = note;
  var reveal = document.getElementById('codeReveal');
  if (reveal) { reveal.classList.remove('visible'); void reveal.offsetWidth; reveal.classList.add('visible'); }
  var bw = document.getElementById('btnWhite');
  var bb = document.getElementById('btnBeige');
  if (bw) bw.classList.toggle('free-gift__btn--active', isWhite);
  if (bb) bb.classList.toggle('free-gift__btn--active', !isWhite);
};
window.copyCode = function () {
  var el = document.getElementById('codeText');
  if (!el || !el.textContent) return;
  navigator.clipboard.writeText(el.textContent).then(function () {
    var disp = document.getElementById('codeDisplay');
    var orig = disp.innerHTML;
    disp.innerHTML = '<span>Copied! ✓</span>';
    setTimeout(function () { disp.innerHTML = orig; }, 1800);
  });
};

/* ============================================================
   LEGAL MODALS
   ============================================================ */
var MODAL_CONTENT = {
  privacy: {
    title: 'Privacy Policy',
    updated: 'Last updated: May 2026',
    body:
      '<p>We collect only what we need to process your order and provide good customer service. We never sell your personal data. Ever.</p>' +
      '<hr class="lw-modal__divider">' +
      '<h3>What We Collect</h3>' +
      '<ul><li>Name, email address, shipping address, and phone number (if provided)</li>' +
      '<li>Payment details — processed securely by Shopify Payments. We never store your card number.</li>' +
      '<li>Basic cookies to keep your shopping cart working between pages</li></ul>' +
      '<h3>How We Use It</h3>' +
      '<ul><li>To fulfill and ship your order</li><li>To send order confirmations and tracking updates</li><li>To respond to customer service inquiries</li></ul>' +
      '<h3>Third Parties</h3>' +
      '<p>Your payment is processed by Shopify Payments (PCI-compliant). Your order ships via USPS or UPS. We share only what\'s necessary to deliver your order — nothing more.</p>' +
      '<h3>Cookies</h3>' +
      '<p>We use essential cookies to keep your cart working. We do not use advertising tracking cookies or retargeting pixels.</p>' +
      '<h3>Your Rights</h3>' +
      '<p>You can request to see, correct, or delete your personal data at any time by emailing us at <a href="mailto:info@linenwave.com">info@linenwave.com</a>.</p>' +
      '<h3>California Residents (CCPA)</h3>' +
      '<p>You have the right to know what personal information we collect and to request its deletion. We do not sell personal information to third parties.</p>' +
      '<h3>Contact</h3>' +
      '<p><a href="mailto:info@linenwave.com">info@linenwave.com</a> · 310-496-9095</p>'
  },
  terms: {
    title: 'Terms of Service',
    updated: 'Last updated: May 2026',
    body:
      '<p>By placing an order on LinenWave.com you agree to the following terms.</p>' +
      '<hr class="lw-modal__divider">' +
      '<h3>Products</h3>' +
      '<p>All products are 100% French stonewashed linen. Colors may vary slightly between screens due to monitor calibration differences. We do our best to represent all colors accurately in our product photography.</p>' +
      '<h3>Pricing</h3>' +
      '<p>All prices are in US dollars. We reserve the right to correct any pricing errors at any time.</p>' +
      '<h3>Orders</h3>' +
      '<p>Orders placed Monday–Friday are processed the same day. Orders placed on weekends ship the following Monday. You\'ll receive an email confirmation with tracking once your order ships.</p>' +
      '<h3>Coupon Codes</h3>' +
      '<p>One coupon code per order. Codes cannot be combined with other promotions. Free gift codes (WHITEPILLOW / BEIGEPILLOW) apply to orders of $150 or more and are subject to availability.</p>' +
      '<h3>Intellectual Property</h3>' +
      '<p>All content on this site — photography, copy, design, and branding — belongs to Linen Wave. Do not reproduce without written permission.</p>' +
      '<h3>Limitation of Liability</h3>' +
      '<p>Linen Wave is not liable for shipping delays caused by carriers, weather, or circumstances outside our control.</p>' +
      '<h3>Questions</h3>' +
      '<p><a href="mailto:info@linenwave.com">info@linenwave.com</a> · 310-496-9095</p>'
  }
};

window.openModal = function (type) {
  var content = MODAL_CONTENT[type];
  if (!content) return;
  document.getElementById('modalTitle').textContent = content.title;
  document.getElementById('modalUpdated').textContent = content.updated;
  document.getElementById('modalBody').innerHTML = content.body;
  document.getElementById('legalModal').classList.add('open');
  document.body.style.overflow = 'hidden';
};
window.closeModal = function () {
  document.getElementById('legalModal').classList.remove('open');
  document.body.style.overflow = '';
};
window.handleOverlayClick = function (e) {
  if (e.target === document.getElementById('legalModal')) window.closeModal();
};

/* ============================================================
   EXCLUSIVE OFFER — variant selector + sticky bar
   Markup lives in sections/exclusive-offer.liquid; this reuses the
   existing window.addToCart(), the shared cart drawer, and formatPrice()
   above — no duplicate cart or price logic. Runs only when the exclusive
   offer block is on the page (guarded), so it is inert everywhere else.
   ============================================================ */
function initExclusiveOffer() {
  var grid = document.querySelector('[data-exclusive-offer]');
  if (!grid) return;

  var variants = [];
  try { variants = JSON.parse(grid.dataset.variants || '[]'); } catch (e) { variants = []; }
  var COLOR_IDX = parseInt(grid.dataset.colorIdx, 10); if (isNaN(COLOR_IDX)) COLOR_IDX = -1;
  var SIZE_IDX = parseInt(grid.dataset.sizeIdx, 10); if (isNaN(SIZE_IDX)) SIZE_IDX = -1;
  var productTitle = grid.dataset.productTitle || '';

  var firstVariant = variants.filter(function (v) { return v.available; })[0] || variants[0];
  var state = {
    color: (COLOR_IDX >= 0 && firstVariant) ? firstVariant.options[COLOR_IDX] : null,
    size: (SIZE_IDX >= 0 && firstVariant) ? firstVariant.options[SIZE_IDX] : null
  };

  function currentVariant() {
    return variants.filter(function (v) {
      var ok = true;
      if (COLOR_IDX >= 0) ok = ok && v.options[COLOR_IDX] === state.color;
      if (SIZE_IDX >= 0) ok = ok && v.options[SIZE_IDX] === state.size;
      return ok;
    })[0];
  }

  var addBtn = document.getElementById('exclusiveAddToCart');
  var priceMain = document.getElementById('exclusivePriceMain');
  var priceCompare = document.getElementById('exclusivePriceCompare');
  var stickyPriceEl = null;

  function setAddBtnLabel(text) {
    if (!addBtn) return;
    if (addBtn.childNodes.length && addBtn.childNodes[0].nodeType === 3) {
      addBtn.childNodes[0].nodeValue = text + ' ';
    } else {
      addBtn.insertBefore(document.createTextNode(text + ' '), addBtn.firstChild);
    }
  }

  function updateAll() {
    var v = currentVariant();
    if (!v) {
      if (addBtn) { setAddBtnLabel('Unavailable'); addBtn.disabled = true; }
      return;
    }
    if (priceMain && priceMain.childNodes[0]) priceMain.childNodes[0].nodeValue = formatPrice(v.price);
    if (priceCompare) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceCompare.style.display = '';
        if (priceCompare.childNodes[0]) priceCompare.childNodes[0].nodeValue = formatPrice(v.compare_at_price);
      } else {
        priceCompare.style.display = 'none';
      }
    }
    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.dataset.variantId = v.id;
      setAddBtnLabel(v.available ? 'Add to Cart — ' + formatPrice(v.price) : 'Sold Out');
    }
    if (stickyPriceEl) stickyPriceEl.textContent = formatPrice(v.price) + ' · Free US Shipping';

    var mainImg = document.getElementById('exclusiveMainImg');
    if (mainImg && v.image) mainImg.src = v.image;

    if (SIZE_IDX >= 0) {
      document.querySelectorAll('#exclusiveSizeSwatches .size-swatch').forEach(function (btn) {
        var sz = btn.dataset.size;
        var match = variants.filter(function (vv) {
          var ok = vv.options[SIZE_IDX] === sz;
          if (COLOR_IDX >= 0) ok = ok && vv.options[COLOR_IDX] === state.color;
          return ok;
        })[0];
        var soldOut = !match || !match.available;
        btn.classList.toggle('sold-out', soldOut);
        btn.disabled = soldOut;
      });
    }
  }

  document.querySelectorAll('#exclusiveColorSwatches .color-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('#exclusiveColorSwatches .color-swatch').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.color = btn.dataset.color;
      var label = document.getElementById('exclusiveSelectedColor');
      if (label) label.textContent = state.color;
      updateAll();
    });
  });

  document.querySelectorAll('#exclusiveSizeSwatches .size-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      document.querySelectorAll('#exclusiveSizeSwatches .size-swatch').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.size = btn.dataset.size;
      var label = document.getElementById('exclusiveSelectedSize');
      if (label) label.textContent = state.size;
      updateAll();
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var v = currentVariant();
      if (!v || !v.available) return;
      var original = addBtn.innerHTML;
      addBtn.disabled = true;
      window.addToCart(v.id, 1).then(function () {
        setTimeout(function () { addBtn.innerHTML = original; addBtn.disabled = false; }, 2000);
      });
    });
  }

  document.querySelectorAll('.exclusive-offer-block__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.getElementById('exclusiveMainImg');
      if (main && btn.dataset.full) main.src = btn.dataset.full;
      document.querySelectorAll('.exclusive-offer-block__thumb').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Sticky mobile add-to-cart bar — product name + live price, links back to the offer.
  var sticky = document.createElement('div');
  sticky.className = 'exclusive-sticky';
  sticky.id = 'exclusiveSticky';
  sticky.innerHTML =
    '<div class="exclusive-sticky__inner">' +
      '<div class="exclusive-sticky__text">' +
        '<div class="exclusive-sticky__name"></div>' +
        '<div class="exclusive-sticky__price" id="exclusiveStickyPrice"></div>' +
      '</div>' +
      '<a href="#offer" class="btn btn--primary" style="font-size:0.68rem;padding:0.75rem 1.25rem;">View Offer</a>' +
    '</div>';
  sticky.querySelector('.exclusive-sticky__name').textContent = productTitle;
  document.body.appendChild(sticky);
  stickyPriceEl = document.getElementById('exclusiveStickyPrice');

  var heroEl = document.querySelector('.exclusive-hero');
  var footerEl = document.querySelector('.exclusive-minimal-footer');
  function tick() {
    if (!heroEl) return;
    var hb = heroEl.getBoundingClientRect().bottom;
    var fb = footerEl ? footerEl.getBoundingClientRect().top : Infinity;
    sticky.style.display = (hb < 0 && fb > window.innerHeight) ? 'block' : 'none';
  }
  window.addEventListener('scroll', tick, { passive: true });

  updateAll();
  tick();
}

/* ============================================================
   INIT
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  refreshCart(false);
  initHeaderScroll();
  initAnnouncementBar();
  initEmailSignup();
  initScrollReveal();
  initAccordions('[data-accordion]');
  initExclusiveOffer();

  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', openCart);
  var cartOverlay = document.getElementById('cartOverlay');
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  var cartCloseBtn = document.getElementById('cartCloseBtn');
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  var checkoutBtn = document.getElementById('checkoutBtn');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });

  var hamburger = document.querySelector('.hamburger');
  if (hamburger) hamburger.addEventListener('click', toggleMobileNav);
  document.querySelectorAll('.mobile-nav__link, .mobile-nav__sub a').forEach(function (a) {
    a.addEventListener('click', function () {
      var mn = document.getElementById('mobileNav');
      if (mn) mn.classList.remove('open');
      var hb = document.querySelector('.hamburger');
      if (hb) hb.classList.remove('open');
      document.body.style.overflow = '';
    });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { window.closeModal(); closeCart(); } });
});
